
export default {
  name: "PostHero",
  props: {
    post: Object,
    getImageOfSize: Function,
    responsiveSize: Object,
    webpURL: String,
    widthAttribute: Number,
    heightAttribute: Number,
    alternativeText: String,
    imageAttributes: Object,
  },
}
